const ITEMS = [
  { key: "total", label: "Mensagens (24h)", color: "#F9FAFB" },
  { key: "panel", label: "Respostas do Painel", color: "#A78BFA" },
  { key: "ai", label: "Respostas da IA", color: "#34D399" },
  { key: "contacts", label: "Contatos", color: "#22D3EE" },
];

export const Metrics = ({ stats }) => (
  <section className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="metrics-grid">
    {ITEMS.map(({ key, label, color }) => (
      <div key={key} className="metric-card" data-testid={`metric-${key}`}>
        <p className="text-xs text-[#6B7280] uppercase tracking-wider font-mono">{label}</p>
        <p className="font-heading text-3xl font-bold mt-2" style={{ color }}>{stats ? stats[key] : "–"}</p>
      </div>
    ))}
  </section>
);
